var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noWrap)?_c('div',[_vm._t("default")],2):_c('div',{staticClass:"form-group",class:{
	'is-invalid' : _vm.invalid, 
	row: _vm.colClass != 'stacked' && !_vm.controlLeft,
	'd-flex flex-row align-items-center': _vm.controlLeft
}},[_c('label',{staticClass:"col-form-label",class:_vm.labelClass,domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":function($event){return _vm.$emit('clickLabel')}}}),_c('div',{class:_vm.controlLeft ? '' : _vm.fieldClass,style:({
			order:_vm.controlLeft ? -1 : 'default',
		})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }